/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { CognitoUser } from '@aws-amplify/auth';
import { Action, createReducer, on } from '@ngrx/store';
import * as AuthActions from './auth.actions';
import { cloneDeep } from 'lodash';

export interface AuthState {
  user: CognitoUser;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
};

const reducer = createReducer(
  initialState,
  on(AuthActions.SetAuthenticated, (state: AuthState, action) => ({
      ...state,
      isAuthenticated: true,
    })),
  on(AuthActions.SetUnauthenticated, (state: AuthState, action) => ({
      ...state,
      isAuthenticated: false,
    })),
  on(AuthActions.DoFirstLogin, (state: AuthState, action) => ({
      ...state,
      isAuthenticated: false,
    })),
);

export function authReducers(state: AuthState, action: Action) {
  return reducer(state, action);
}
